import i18n from "@/plugins/i18n"

const avatarCategories = {
  topType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "NoHair",
      text: i18n.t("avatar.NoHair"),
    },
    {
      value: "Eyepatch",
      text: i18n.t("avatar.Eyepatch"),
    },
    {
      value: "Hat",
      text: i18n.t("avatar.Hat"),
    },
    {
      value: "Hijab",
      text: i18n.t("avatar.Hijab"),
    },
    {
      value: "Turban",
      text: i18n.t("avatar.Turban"),
    },
    {
      value: "WinterHat1",
      text: i18n.t("avatar.WinterHat1"),
    },
    {
      value: "WinterHat2",
      text: i18n.t("avatar.WinterHat2"),
    },
    {
      value: "WinterHat3",
      text: i18n.t("avatar.WinterHat3"),
    },
    {
      value: "WinterHat4",
      text: i18n.t("avatar.WinterHat4"),
    },
    {
      value: "LongHairBigHair",
      text: i18n.t("avatar.LongHairBigHair"),
    },
    {
      value: "LongHairBob",
      text: i18n.t("avatar.LongHairBob"),
    },
    {
      value: "LongHairBun",
      text: i18n.t("avatar.LongHairBun"),
    },
    {
      value: "LongHairCurly",
      text: i18n.t("avatar.LongHairCurly"),
    },
    {
      value: "LongHairCurvy",
      text: i18n.t("avatar.LongHairCurvy"),
    },
    {
      value: "LongHairDreads",
      text: i18n.t("avatar.LongHairDreads"),
    },
    {
      value: "LongHairFrida",
      text: i18n.t("avatar.LongHairFrida"),
    },
    {
      value: "LongHairFro",
      text: i18n.t("avatar.LongHairFro"),
    },
    {
      value: "LongHairFroBand",
      text: i18n.t("avatar.LongHairFroBand"),
    },
    {
      value: "LongHairNotTooLong",
      text: i18n.t("avatar.LongHairNotTooLong"),
    },
    {
      value: "LongHairShavedSides",
      text: i18n.t("avatar.LongHairShavedSides"),
    },
    {
      value: "LongHairMiaWallace",
      text: i18n.t("avatar.LongHairMiaWallace"),
    },
    {
      value: "LongHairStraight",
      text: i18n.t("avatar.LongHairStraight"),
    },
    {
      value: "LongHairStraight2",
      text: i18n.t("avatar.LongHairStraight2"),
    },
    {
      value: "LongHairStraightStrand",
      text: i18n.t("avatar.LongHairStraightStrand"),
    },
    {
      value: "ShortHairDreads01",
      text: i18n.t("avatar.ShortHairDreads01"),
    },
    {
      value: "ShortHairDreads02",
      text: i18n.t("avatar.ShortHairDreads02"),
    },
    {
      value: "ShortHairFrizzle",
      text: i18n.t("avatar.ShortHairFrizzle"),
    },
    {
      value: "ShortHairShaggyMullet",
      text: i18n.t("avatar.ShortHairShaggyMullet"),
    },
    {
      value: "ShortHairShortCurly",
      text: i18n.t("avatar.ShortHairShortCurly"),
    },
    {
      value: "ShortHairShortFlat",
      text: i18n.t("avatar.ShortHairShortFlat"),
    },
    {
      value: "ShortHairShortRound",
      text: i18n.t("avatar.ShortHairShortRound"),
    },
    {
      value: "ShortHairShortWaved",
      text: i18n.t("avatar.ShortHairShortWaved"),
    },
    {
      value: "ShortHairSides",
      text: i18n.t("avatar.ShortHairSides"),
    },
    {
      value: "ShortHairTheCaesar",
      text: i18n.t("avatar.ShortHairTheCaesar"),
    },
    {
      value: "ShortHairTheCaesarSidePart",
      text: i18n.t("avatar.ShortHairTheCaesarSidePart"),
    },
  ],
  accessoriesType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Blank",
      text: i18n.t("avatar.Blank"),
    },
    {
      value: "Kurt",
      text: i18n.t("avatar.Kurt"),
    },
    {
      value: "Prescription01",
      text: i18n.t("avatar.Prescription01"),
    },
    {
      value: "Prescription02",
      text: i18n.t("avatar.Prescription02"),
    },
    {
      value: "Round",
      text: i18n.t("avatar.Round"),
    },
    {
      value: "Sunglasses",
      text: i18n.t("avatar.Sunglasses"),
    },
    {
      value: "Wayfarers",
      text: i18n.t("avatar.Wayfarers"),
    },
  ],
  facialHairType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Blank",
      text: i18n.t("avatar.Blank"),
    },
    {
      value: "BeardMedium",
      text: i18n.t("avatar.BeardMedium"),
    },
    {
      value: "BeardLight",
      text: i18n.t("avatar.BeardLight"),
    },
    {
      value: "BeardMagestic",
      text: i18n.t("avatar.BeardMagestic"),
    },
    {
      value: "MoustacheFancy",
      text: i18n.t("avatar.MoustacheFancy"),
    },
    {
      value: "MoustacheMagnum",
      text: i18n.t("avatar.MoustacheMagnum"),
    },
  ],
  facialHairColor: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Auburn",
      text: i18n.t("avatar.Auburn"),
    },
    {
      value: "Black",
      text: i18n.t("avatar.Black"),
    },
    {
      value: "Blonde",
      text: i18n.t("avatar.Blonde"),
    },
    {
      value: "BlondeGolden",
      text: i18n.t("avatar.BlondeGolden"),
    },
    {
      value: "Brown",
      text: i18n.t("avatar.Brown"),
    },
    {
      value: "BrownDark",
      text: i18n.t("avatar.BrownDark"),
    },
    {
      value: "PastelPink",
      text: i18n.t("avatar.PastelPink"),
    },
    {
      value: "Platinum",
      text: i18n.t("avatar.Platinum"),
    },
    {
      value: "Red",
      text: i18n.t("avatar.Red"),
    },
    {
      value: "SilverGray",
      text: i18n.t("avatar.SilverGray"),
    },
  ],
  clotheType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "BlazerShirt",
      text: i18n.t("avatar.BlazerShirt"),
    },
    {
      value: "BlazerSweater",
      text: i18n.t("avatar.BlazerSweater"),
    },
    {
      value: "CollarSweater",
      text: i18n.t("avatar.CollarSweater"),
    },
    {
      value: "GraphicShirt",
      text: i18n.t("avatar.GraphicShirt"),
    },
    {
      value: "Hoodie",
      text: i18n.t("avatar.Hoodie"),
    },
    {
      value: "Overall",
      text: i18n.t("avatar.Overall"),
    },
    {
      value: "ShirtCrewNeck",
      text: i18n.t("avatar.ShirtCrewNeck"),
    },
    {
      value: "ShirtScoopNeck",
      text: i18n.t("avatar.ShirtScoopNeck"),
    },
    {
      value: "ShirtVNeck",
      text: i18n.t("avatar.ShirtVNeck"),
    },
  ],
  eyeType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Close",
      text: i18n.t("avatar.Close"),
    },
    {
      value: "Cry",
      text: i18n.t("avatar.Cry"),
    },
    {
      value: "Default",
      text: i18n.t("avatar.Default"),
    },
    {
      value: "Dizzy",
      text: i18n.t("avatar.Dizzy"),
    },
    {
      value: "EyeRoll",
      text: i18n.t("avatar.EyeRoll"),
    },
    {
      value: "Happy",
      text: i18n.t("avatar.Happy"),
    },
    {
      value: "Hearts",
      text: i18n.t("avatar.Hearts"),
    },
    {
      value: "Side",
      text: i18n.t("avatar.Side"),
    },
    {
      value: "Squint",
      text: i18n.t("avatar.Squint"),
    },
    {
      value: "Surprised",
      text: i18n.t("avatar.Surprised"),
    },
    {
      value: "Wink",
      text: i18n.t("avatar.Wink"),
    },
    {
      value: "WinkWacky",
      text: i18n.t("avatar.WinkWacky"),
    },
  ],
  eyebrowType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Default",
      text: i18n.t("avatar.Default"),
    },
    {
      value: "DefaultNatural",
      text: i18n.t("avatar.DefaultNatural"),
    },
    {
      value: "FlatNatural",
      text: i18n.t("avatar.FlatNatural"),
    },
    {
      value: "RaisedExcited",
      text: i18n.t("avatar.RaisedExcited"),
    },
    {
      value: "RaisedExcitedNatural",
      text: i18n.t("avatar.RaisedExcitedNatural"),
    },
    {
      value: "UpDown",
      text: i18n.t("avatar.UpDown"),
    },
    {
      value: "UpDownNatural",
      text: i18n.t("avatar.UpDownNatural"),
    },
  ],
  mouthType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Concerned",
      text: i18n.t("avatar.Concerned"),
    },
    {
      value: "Default",
      text: i18n.t("avatar.Default"),
    },
    {
      value: "Disbelief",
      text: i18n.t("avatar.Disbelief"),
    },
    {
      value: "Eating",
      text: i18n.t("avatar.Eating"),
    },
    {
      value: "Grimace",
      text: i18n.t("avatar.Grimace"),
    },
    {
      value: "Sad",
      text: i18n.t("avatar.Sad"),
    },
    {
      value: "ScreamOpen",
      text: i18n.t("avatar.ScreamOpen"),
    },
    {
      value: "Serious",
      text: i18n.t("avatar.Serious"),
    },
    {
      value: "Smile",
      text: i18n.t("avatar.Smile"),
    },
    {
      value: "Tongue",
      text: i18n.t("avatar.Tongue"),
    },
    {
      value: "Twinkle",
      text: i18n.t("avatar.Twinkle"),
    },
  ],
  skinColor: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Tanned",
      text: i18n.t("avatar.Tanned"),
    },
    {
      value: "Yellow",
      text: i18n.t("avatar.Yellow"),
    },
    {
      value: "Pale",
      text: i18n.t("avatar.Pale"),
    },
    {
      value: "Light",
      text: i18n.t("avatar.Light"),
    },
    {
      value: "Brown",
      text: i18n.t("avatar.Brown"),
    },
    {
      value: "DarkBrown",
      text: i18n.t("avatar.DarkBrown"),
    },
    {
      value: "Black",
      text: i18n.t("avatar.Black"),
    },
  ],
  graphicType: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Bat",
      text: i18n.t("avatar.Bat"),
    },
    {
      value: "Cumbia",
      text: i18n.t("avatar.Cumbia"),
    },
    {
      value: "Deer",
      text: i18n.t("avatar.Deer"),
    },
    {
      value: "Diamond",
      text: i18n.t("avatar.Diamond"),
    },
    {
      value: "Hola",
      text: i18n.t("avatar.Hola"),
    },
    {
      value: "Pizza",
      text: i18n.t("avatar.Pizza"),
    },
    {
      value: "Resist",
      text: i18n.t("avatar.Resist"),
    },
    {
      value: "Selena",
      text: i18n.t("avatar.Selena"),
    },
    {
      value: "Bear",
      text: i18n.t("avatar.Bear"),
    },
    {
      value: "SkullOutline",
      text: i18n.t("avatar.SkullOutline"),
    },
    {
      value: "Skull",
      text: i18n.t("avatar.Skull"),
    },
  ],
  hairColor: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Auburn",
      text: i18n.t("avatar.Auburn"),
    },
    {
      value: "Black",
      text: i18n.t("avatar.Black"),
    },
    {
      value: "Blonde",
      text: i18n.t("avatar.Blonde"),
    },
    {
      value: "BlondeGolden",
      text: i18n.t("avatar.BlondeGolden"),
    },
    {
      value: "Brown",
      text: i18n.t("avatar.Brown"),
    },
    {
      value: "BrownDark",
      text: i18n.t("avatar.BrownDark"),
    },
    {
      value: "PastelPink",
      text: i18n.t("avatar.PastelPink"),
    },
    {
      value: "Platinum",
      text: i18n.t("avatar.Platinum"),
    },
    {
      value: "Red",
      text: i18n.t("avatar.Red"),
    },
    {
      value: "SilverGray",
      text: i18n.t("avatar.SilverGray"),
    },
  ],
  clotheColor: [
    {
      value: "random",
      text: i18n.t("avatar.random"),
    },
    {
      value: "Black",
      text: i18n.t("avatar.Black"),
    },
    {
      value: "Blue01",
      text: i18n.t("avatar.Blue01"),
    },
    {
      value: "Blue02",
      text: i18n.t("avatar.Blue02"),
    },
    {
      value: "Blue03",
      text: i18n.t("avatar.Blue03"),
    },
    {
      value: "Gray01",
      text: i18n.t("avatar.Gray01"),
    },
    {
      value: "Gray02",
      text: i18n.t("avatar.Gray02"),
    },
    {
      value: "Heather",
      text: i18n.t("avatar.Heather"),
    },
    {
      value: "PastelBlue",
      text: i18n.t("avatar.PastelBlue"),
    },
    {
      value: "PastelGreen",
      text: i18n.t("avatar.PastelGreen"),
    },
    {
      value: "PastelOrange",
      text: i18n.t("avatar.PastelOrange"),
    },
    {
      value: "PastelRed",
      text: i18n.t("avatar.PastelRed"),
    },
    {
      value: "PastelYellow",
      text: i18n.t("avatar.PastelYellow"),
    },
    {
      value: "Pink",
      text: i18n.t("avatar.Pink"),
    },
    {
      value: "Red",
      text: i18n.t("avatar.Red"),
    },
    {
      value: "White",
      text: i18n.t("avatar.White"),
    },
  ],
}

export function getDialogOptions(currentOptions) {
  // :object currentOptions: the current avatar options has. e.g., { topType: "Hat", clotheColor: "Red", ... }
  // used to get the default dialog value
  const dialogOptions = []
  for (const [category, choices] of Object.entries(avatarCategories)) {
    dialogOptions.push({
      name: category,
      label: i18n.t(`avatar.${category}`),
      type: "select",
      rule: "required",
      value: currentOptions[category],
      choices,
    })
  }
  return dialogOptions
}

export const defaultAvatarOptions = {
  topType: "Hat",
  accessoriesType: "Prescription02",
  facialHairType: "Blank",
  facialHairColor: "random",
  clotheType: "CollarSweater",
  eyeType: "Default",
  eyebrowType: "Default",
  mouthType: "Smile",
  skinColor: "Brown",
  graphicType: "Diamond",
  hairColor: "Brown",
  clotheColor: "White",
}
